import React from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientFinancialSupport = () => {
  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden">
        
        {/* HERO SECTION */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#f4f7f6" }}>
          <div className="container py-lg-5">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0 pe-lg-5">
                <h6 className="text-success font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "2px" }}>
                  Make an Impact
                </h6>
                <h1 className="font-weight-bold montserrat text-primary mb-4" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  Financial <span className="text-success">Support.</span>
                </h1>
                <p className="font-size-18 text-muted line-hight-3 mb-4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Your generous contributions help us provide critical resources, early intervention, and educational programs for children and families in need.
                </p>
                <div className="d-flex gap-3 mt-4">
                  <button className="btn btn-success btn-lg font-weight-bold px-4 py-3 rounded-3">
                    Donate Now
                  </button>
                  <button className="btn btn-outline-primary btn-lg font-weight-bold px-4 py-3 rounded-3">
                    Apply for Assistance
                  </button>
                </div>
              </div>
              <div className="col-lg-6">
                <img
                  src="/assets/images/about-img.jpg"
                  alt="Financial Support"
                  className="w-100 rounded-4 shadow-lg"
                  style={{ objectFit: "cover", height: "450px" }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* DONATION TIERS SECTION */}
        <section className="py-5 my-4">
          <div className="container py-lg-4">
            <div className="text-center mb-5">
              <h2 className="font-weight-bold montserrat text-primary font-size-46 mb-3">Ways to Give</h2>
              <div className="mx-auto bg-success" style={{ height: "3px", width: "60px" }}></div>
              <p className="text-muted font-size-16 mt-3">Choose how you would like to support our mission.</p>
            </div>
            
            <div className="row g-4 justify-content-center">
              {/* Tier 1 */}
              <div className="col-md-6 col-lg-4">
                <div className="card border-0 shadow-sm rounded-4 p-4 h-100 text-center transition-hover">
                  <h4 className="font-weight-bold text-primary mb-2">One-Time Gift</h4>
                  <h2 className="font-weight-bold text-success font-size-46 mb-3">$50</h2>
                  <p className="text-muted font-size-15 mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Provides essential supplies for one child.</p>
                  <button className="btn btn-outline-success w-100 font-weight-bold py-2 rounded-3 mt-auto">Select Amount</button>
                </div>
              </div>
              {/* Tier 2 - Highlighted */}
              <div className="col-md-6 col-lg-4">
                <div className="card border-0 shadow-lg rounded-4 p-4 h-100 text-center position-relative" style={{ backgroundColor: "#083B5C", transform: "scale(1.05)" }}>
                  <div className="position-absolute top-0 start-50 translate-middle badge bg-success px-3 py-2 rounded-pill font-size-12 text-uppercase tracking-wide">Most Popular</div>
                  <h4 className="font-weight-bold text-white mb-2 mt-2">Monthly Hero</h4>
                  <h2 className="font-weight-bold text-success font-size-46 mb-3">$100<span className="font-size-16 text-white opacity-50">/mo</span></h2>
                  <p className="text-white opacity-75 font-size-15 mb-4">Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sustains ongoing programs.</p>
                  <button className="btn btn-success w-100 font-weight-bold py-2 rounded-3 mt-auto text-white">Become a Hero</button>
                </div>
              </div>
              {/* Tier 3 */}
              <div className="col-md-6 col-lg-4">
                <div className="card border-0 shadow-sm rounded-4 p-4 h-100 text-center transition-hover">
                  <h4 className="font-weight-bold text-primary mb-2">Corporate Sponsor</h4>
                  <h2 className="font-weight-bold text-success font-size-46 mb-3">Custom</h2>
                  <p className="text-muted font-size-15 mb-4">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                  <button className="btn btn-outline-success w-100 font-weight-bold py-2 rounded-3 mt-auto">Contact Us</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ASSISTANCE / GRANT SECTION */}
        <section className="py-5" style={{ backgroundColor: "#083B5C" }}>
          <div className="container py-lg-5">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <img
                  src="/assets/images/about-img.jpg"
                  alt="Apply for assistance"
                  className="w-100 rounded-4 shadow-lg"
                  style={{ objectFit: "cover", height: "400px", border: "4px solid #ffffff" }}
                />
              </div>
              <div className="col-lg-6 ps-lg-5">
                <h3 className="font-weight-bold font-size-32 mb-4 text-white">Need Financial Assistance?</h3>
                <p className="text-white opacity-75 font-size-16 line-hight-3 mb-4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. We offer grants and financial assistance to families who qualify. If you are seeking support for developmental resources, therapies, or educational tools, we are here to help.
                </p>
                <ul className="list-unstyled text-white opacity-75 font-size-15 mb-4" style={{ lineHeight: "2" }}>
                  <li>✔ Eligibility criteria 1 (Lorem ipsum)</li>
                  <li>✔ Eligibility criteria 2 (Dolor sit amet)</li>
                  <li>✔ Eligibility criteria 3 (Consectetur adipiscing)</li>
                </ul>
                <button className="btn btn-success btn-lg font-weight-bold px-4 py-3 rounded-3 mt-2">
                  Start Application
                </button>
              </div>
            </div>
          </div>
        </section>

      </main>
      <ClientFooter />
    </>
  );
};

export default ClientFinancialSupport;